import React from 'react';
import { TaskCommentEditorModal } from './comment-editor/TaskCommentEditorModal.jsx';

// Los 2 modales del editor de comentarios expandido (crear / editar) del panel de detalle de
// una tarea (integración main→dev, epic D1.4 — extraído del slot inline `commentEditorModals`
// de `ComponentTaskHoy` para hacer sitio, bajo el ratchet, al cableado del Cuadro de Trabajo).
// Presentacional.

export const TaskCommentEditorModals = ({
    expandedCommentEditor,
    onClose,
    translate,
    canComment,
    canTagUsers,
    usersToSelectFrom,
    userId,
    createDraftContent,
    createResetKey,
    onCreateContentChange,
    onSubmitComment,
    onSmartTagsChange,
    onMentionSelect,
    editDraftContent,
    editingCommentId,
    editingCommentContent,
    onEditContentChange,
    onSaveEdit,
    onCancelEdit,
}) => {
    const users = canTagUsers ? usersToSelectFrom : [];
    return (
        <>
            {canComment && (
                <TaskCommentEditorModal
                    isOpen={expandedCommentEditor === 'create'}
                    onClose={onClose}
                    translate={translate}
                    mode="create"
                    content={createDraftContent}
                    resetKey={createResetKey}
                    onContentChange={onCreateContentChange}
                    onSubmit={onSubmitComment}
                    onSmartTagsChange={onSmartTagsChange}
                    onMentionSelect={onMentionSelect}
                    users={users}
                    userId={userId}
                    placeholder={translate('comments.writePlaceholder')}
                />
            )}
            <TaskCommentEditorModal
                isOpen={expandedCommentEditor === 'edit'}
                onClose={onClose}
                translate={translate}
                mode="edit"
                content={editDraftContent || editingCommentContent || ''}
                resetKey={editingCommentId}
                onContentChange={onEditContentChange}
                onSave={onSaveEdit}
                onCancel={onCancelEdit}
                users={users}
                userId={userId}
            />
        </>
    );
};

export default TaskCommentEditorModals;
